<template>
  <a-modal
    v-model:visible="visible"
    title="表盘息屏（AOD）信息"
    ok-text="关闭"
    :width="950"
    :body-style="{
      minHeight: '300px',
      maxHeight: '700px',
      overflow: 'auto'
    }"
    @ok="handleOk"
  >
    <div>
      <!-- loading -->
      <div
        v-if="loading"
        class="w-full flex justify-center items-center h-[200px]"
      >
        <a-spin tip="校验中..." size="large" />
      </div>

      <!-- 校验结果 -->
      <template v-else>
        <a-alert
          v-if="hasInvalid"
          message="息屏校验失败，请调整！"
          type="error"
          class="mb-3"
        />
        <a-alert
          v-else
          message="息屏校验通过"
          type="success"
          class="mb-3"
        />
        <WatchfaceAODValid :data="validationData" @close="handleOk" />
      </template>
    </div>
    <template #footer>
      <a-button @click="handleOk">关闭</a-button>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { AodThemeValidRse, useWatchfaceAodPixel } from '@/hooks';

const { validAODPixels } = useWatchfaceAodPixel();

const visible = ref(false);
const loading = ref(false);
const validationData = ref<AodThemeValidRse[]>([]);

const hasInvalid = computed(() =>
  validationData.value.some(
    (item) =>
      item.nonBlack?.valid === false ||
      item.illegalColor?.valid === false ||
      item.RGB?.movable?.valid === false ||
      item.RGB?.partiallyMovable?.valid === false ||
      item.RGB?.notMovable?.valid === false
  )
);

defineExpose({
  open: async () => {
    visible.value = true;
    loading.value = true;
    try {
      validationData.value = (await validAODPixels())?.details ?? [];
    } catch (error) {
      console.error('AOD validation error:', error);
      validationData.value = [];
    } finally {
      loading.value = false;
    }
  }
});

const handleOk = () => {
  visible.value = false;
  validationData.value = [];
};
</script>
